export const adsbWebsocket = `{
  action: "publish",
  topic: "skopa/adsb",
  payload: {
    timestamp: 1771339518393,
    track_id: "EXAMPLE_001",
    icao_address: "ABC123",
    callsign: "G-ABCB",
    position: {
      lat: 50.70933897993415,
      lon: -0.9308096262550821,
    },
    altitude_ft: 20925,
    speed_knots: 359.912109375,
    squawk: "7453",
    category: 21,
    icon: "default",
    intent: "unknown",
    category_name: "ADS-B",
    source: {
      sac: 0,
      sic: 1,
      listener_port: 5002,
    },
  },
};`;

export const WebsocketConnect = `https://DOMAIN-NAME.com/connect`;
